import React, { lazy, Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * Wraps a dynamic import in React.lazy and Suspense.
 * This allows passing lazy components in configuration objects (like appConfig)
 * without breaking the UI that expects a standard Component.
 * 
 * @param {Function} importFunc - e.g. () => import('./MyComponent')
 * @returns {React.Component}
 */
export const lazyComponent = (importFunc) => {
  const LazyComponent = lazy(importFunc);
  
  return (props) => (
    <Suspense fallback={
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
        <CircularProgress size={24} />
      </Box>
    }>
      <LazyComponent {...props} />
    </Suspense>
  );
};